import { css } from "@emotion/react";

import { colors } from "../../../styles";

export const errorMessage = css`
  color: ${colors.primary};
`;
